var map = {
	"./03b381.png": 650677,
	"./368bd6.png": 32453,
	"./ac3ba8.png": 998676,
	"./attach.png": 224230,
	"./call.png": 663110,
	"./cancel-black.png": 876112,
	"./cancel-black2.png": 24767,
	"./cancel.png": 55136,
	"./chevron-left.png": 14390,
	"./chevron-right.png": 232959,
	"./chevron.png": 618449,
	"./close-white.png": 705601,
	"./create-big.png": 816570,
	"./create.png": 274234,
	"./delete.png": 258087,
	"./directory-big.png": 380060,
	"./download.png": 326623,
	"./edit.png": 415486,
	"./file.png": 820391,
	"./filegrid.png": 261466,
	"./fileicon.png": 180736,
	"./filelist.png": 936042,
	"./files.png": 600416,
	"./hide.png": 249794,
	"./info.png": 268343,
	"./list-close.png": 192112,
	"./list-open.png": 418134,
	"./member_chevron.png": 822939,
	"./menu.png": 708016,
	"./newmessages.png": 764643,
	"./placeholder.png": 787052,
	"./search.png": 284566,
	"./selected.png": 206155,
	"./settings-big.png": 156377,
	"./settings.png": 865201,
	"./stickerpack-placeholder.png": 786768,
	"./trans.png": 758233,
	"./typing.png": 431416,
	"./upload-big.png": 811551,
	"./upload.png": 815260,
	"./video.png": 638849,
	"./voice.png": 502946,
	"./voip-mute.png": 590126,
	"./voip.png": 868425,
	"./warning.png": 33820,
	"./warning2.png": 482068,
	"./zoom.png": 119838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958425;